import { PROGRAMS } from 'shared/lib/programs';

export const PROGRAMS_ILLUSTRATIONS: Record<PROGRAMS, string> = {
  [PROGRAMS.CKLA]:
    'https://learning.amplify.com/m/822bb9d3f22551/original/EH-ckla-illustration.svg',
  [PROGRAMS.CAMINOS]:
    'https://learning.amplify.com/m/121ea940a1eb8219/original/EH-caminos-illustration.svg',
  [PROGRAMS.ELAR]:
    'https://learning.amplify.com/m/2636d916470a0a2a/original/EH-elar-illustration.svg',
  [PROGRAMS.ELA]:
    'https://learning.amplify.com/m/3fbd7f0f7f2ee3a2/original/EH-ela-illustration.svg',
  [PROGRAMS.ELD]:
    'https://learning.amplify.com/m/6e8283b535d9e18e/original/EH-eld-illustration.svg',
  [PROGRAMS.MATH]:
    'https://learning.amplify.com/m/70b3442461d69fc7/original/EH-math-illustration.svg',
  [PROGRAMS.SCIENCE]:
    'https://learning.amplify.com/m/3c1283d44b8b7a03/original/EH-science-illustration.svg',
  [PROGRAMS.BOOST]:
    'https://learning.amplify.com/m/627d9bded834ff4f/original/EH-boost-illustration.svg',
  [PROGRAMS.VOCAB_APP]:
    'https://learning.amplify.com/m/4e6b18924c31c26a/original/EH-vocab_app-illustration.svg',
  [PROGRAMS.MATH_SUPPLEMENTAL]:
    'https://learning.amplify.com/m/2728d6c83e333974/original/EH-math_supplemental-illustration.svg',
  [PROGRAMS.MCLASS]:
    'https://learning.amplify.com/m/f0dda380f3be618/original/EH-mclass-illustration.svg',
};

export const DEFAULT_ILLUSTRATION = PROGRAMS_ILLUSTRATIONS.elar;
